module.exports = __webpack_public_path__ + "img/chart.d3524688.svg";